import type { Role } from '@/lib/types'
import { fmtDateTime } from '@/lib/format'
import { Byline, feedbackSource } from '@/components/PersonName'
import type { ReviewDetail } from './types'

/**
 * A resubmitted peer review: the feedback that returned the previous round and the author's reply
 * to it. Lets the reviewer tell rejected feedback from overlooked feedback. What changed is marked
 * in the materials, against whichever round "Compare to" picks.
 */
export function Resubmission({ data, role }: { data: ReviewDetail; role: Role }) {
  const previous = data.previous_submission
  const { round } = data
  if (!previous || round.kind !== 'submission') return null
  const reply = round.author_reply?.trim()
  return (
    <section className="box resubmission" aria-label="Peer feedback and the author’s reply">
      <h3>{previous.feedback ? 'Resubmitted after peer review' : `Resubmitted since the round of ${fmtDateTime(previous.created_at)}`}</h3>
      {previous.feedback && <>
        <div className="small muted">
          <Byline people={data.people} id={previous.feedback_by_id} email={previous.feedback_by_email}
            source={feedbackSource('sme', role)}>{previous.feedback_at && <span>{fmtDateTime(previous.feedback_at)}</span>}</Byline>
        </div>
        <blockquote className="prewrap">{previous.feedback}</blockquote>
      </>}
      <div className="small muted">
        <Byline people={data.people} id={round.author_id} email={round.author_email}
          source="Author’s reply"><span>{fmtDateTime(round.created_at)}</span></Byline>
      </div>
      {reply
        ? <blockquote className="prewrap">{reply}</blockquote>
        : <p className="muted small">No reply was written with this submission.</p>}
    </section>
  )
}
